module.exports = __webpack_public_path__ + "static/media/BalDiwali.7873addd.jpg";